import { useState, useEffect } from 'react';
import { productService } from '@/lib/services/product.service';
import { Product } from '@/types';

export function useProducts(storeId?: string, categoryId?: string, serverId?: string) {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!storeId) {
      setLoading(false);
      return;
    }

    const fetchProducts = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await productService.listByStore(storeId, categoryId, serverId);
        setProducts(data);
      } catch (err) {
        console.error('Erro ao buscar produtos:', err);
        setError('Erro ao carregar produtos');
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [storeId, categoryId, serverId]);

  return { products, loading, error };
}
